/**
 *  EmailStaticContent has the static copy of Email Owner
 */
export default {
  cta: {
    carfaxAppended: 'View the Free CARFAX Report',
    calculator: 'Send Offer',
    // vdp nds button
    calculatorDealSubmitted: 'Update My Offer',
    // vdp nds button (submitted deal)
    calculatorLeaseError: 'Contact Dealer',
    // vdp nds button when lease cannot be calculated
    calculatorOfferSummary: 'Send Offer',
    // vdp nds button
    checkAvailability: 'Request Info',
    contactDealer: 'Contact Dealer',
    // vdp Optional Add-On Protections
    contactTheDealer: 'Contact the dealer',
    // vdp Lender Payment
    contactSeller: 'Contact Seller',
    // vdp features (and packages) modal cta
    creditStatus: 'You have already applied for credit.\n Contact Dealer',
    // vdp nds link
    dealer: 'Email Dealer',
    editOnly: 'Save Changes',
    email: 'Email',
    experianAppended: 'View the Free Vehicle History Report',
    listing: 'Confirm Availability',
    // default
    longHaulDeliveryLongForm: 'Contact dealer for arrival dates and shipping costs.',
    // vdp long haul
    longHaulDeliveryShortForm: 'Ask dealer',
    morePhotos: 'Request More\nPhotos',
    moreInfo: 'Request More\nInfo',
    newlyListedPopover: 'Submit an offer',
    // vehicle badge popover cta sentance case
    quote: 'Get a Price',
    // pre-order Get a Price
    requestInfo: 'Request Info',
    requestPhotos: 'Request Photos',
    seeAvailableOffers: 'See Available Offers',
    seeAllOffers: 'See All Offers',
    seeDetails: 'See Details',
    submitAnOffer: 'Submit an Offer',
    // vehicle badge popover cta
    testDrive: 'Request a Test Drive',
    // vdp dhs
    vehicleDelivery: 'Contact dealer for details',
    // vdp dhs
    vehicleHistoryReport: 'Continue to Vehicle History Report',
    // vdp vhr
    viewAvailableOffers: 'View Available Offers',
    virtualTour: 'Set Up a Time' // vdp dhs
  },
  inquiry: {
    confirmAvailability: {
      label: 'This Vehicle\'s Availability',
      schedule: false
    },
    information: {
      label: 'More Information',
      schedule: false
    },
    scheduleTestDrive: {
      label: 'Schedule a Test Drive',
      schedule: true,
      value: 'TEST_DRIVE'
    },
    vehicleDelivery: {
      label: 'Delivery',
      schedule: false
    },
    vehicleHistory: {
      label: 'Vehicle History Report',
      schedule: false
    }
  },
  title: {
    basic: 'Got Questions? Contact the Dealer',
    calculator: 'Send Offer',
    calculatorOfferSummary: 'Let\'s Get You in the Driver\'s Seat!',
    dealer: 'Contact Dealer',
    default: 'Got Questions? Contact the Dealer',
    editOnly: 'One-Click Email Settings',
    quote: 'Get a Price',
    split: 'Got Questions? Contact the Dealer',
    vehicleHistoryReport: 'Vehicle History Report'
  },
  promotions: {
    tcpa: 'Yes, I authorize the dealer to contact me by texts/calls which may include marketing and be by autodialer. Calls may be pre-recorded. Consent is not required to purchase goods/services.'
  },
  sectionHeading: {
    dhs: 'At Home Services I\'m Interested In',
    quote: 'Vehicle Details and Options'
  },
  confirmation: {
    title: 'Email Confirmation',
    oneClickEnabled: '<strong>Success!</strong> Your changes have been saved. One-click email is enabled.',
    oneClickDisabled: '<strong>Success!</strong> Your changes have been saved. One-click email is disabled.',
    successMessage: '<strong>Success!</strong> Your email has been sent.'
  },
  bapNotSelectedError: {
    title: 'We’re missing a few details for your custom order.',
    errorMessage: 'Please ensure a preference has been selected in each section.'
  },
  errorMessage: 'Hmmm, something went wrong. We\'re working on it and will get it fixed as soon as possible. In the meantime, you can contact them directly at ',
  validationMessages: {
    isProfane: 'Please remove all profanity from your message.',
    hasInvalidChars: 'contains invalid characters.',
    hasInvalidDate: 'Please enter a valid date (MM/DD/YYYY).',
    enterCity: 'Please enter your city.',
    enterAddress: 'Please enter your address.',
    enterZip: 'Please enter your zip.',
    enterFirst: 'Please enter your first name.',
    enterLast: 'Please enter your last name.',
    enterPhone: 'Please enter your phone number.',
    enterState: 'Please choose a state.',
    messageValidations: {
      enterAlphaNumeric: 'Please enter an alphanumeric message to the seller.',
      enterMessage: 'Please enter your message to the seller.',
      isProfane: 'Please remove all profanity from your message.'
    },
    name: {
      isValidName: true,
      isNotProfane: true
    },
    hidden: {
      minLength: 0
    }
  },
  feedback: {
    header: 'You\'ve provided valuable feedback that will help us make our shopping experience better for you.',
    subHeader: 'Please close this message and go back to the vehicle details page.'
  },
  financeDisclaimer: {
    header: 'The dealer will contact you about this offer.',
    subHeader: 'Finance terms are not final and are estimates only. Terms are subject to credit check and approval by dealer. Estimates may not include final tax and registration fees and the dealer will work with you directly on final terms.'
  },
  userProfileIncompleteError: {
    title: 'Oops, looks like something\'s missing. ',
    errorMessage: 'Please update your contact information and try again.'
  },
  contexts: ['availableOffers',
  // vdp price breakdown available offers
  'calculator',
  // vdp nds Send Offer
  'calculatorDealSubmitted',
  // vdp nds Update My Offer
  'calculatorLeaseError',
  // vdp nds button when lease cannot be calculated
  'calculatorOfferSummary',
  // vdp nds Send Offer with offer breakdown
  'compareSendOffer',
  // compare modal Send Offer
  'creditStatus',
  // vdp nds You have already applied for credit. Contact Dealer
  'incentives',
  // vdp incentives modal
  'longHaulDeliveryLongForm',
  // vdp long haul
  'longHaulDeliveryShortForm',
  // vdp long haul
  'mediaGallery',
  // vdp media gallery
  'quote',
  // srp and vdp pre-order Get a Price
  'testDrive',
  // vdp dhs
  'virtualTour',
  // vdp dhs
  'vehicleDelivery',
  // vdp dhs
  'vehicleHistoryReport' // vdp vhr
  ]
};